import * as React from 'react';
import { createContext, useContext } from 'react';
import { Appearance } from './appearance/appearanceTypes';
import { dark } from './appearance/dark';
import { light } from './appearance/light';

export type ThemeAppearance = 'light' | 'dark';

type ThemeProp = {
  appearance?: ThemeAppearance | undefined;
  theme?: Appearance | undefined;
  toggleTheme?: () => {} | undefined;
};

// const toggleTheme = () => {};

const ThemeContext = createContext<ThemeProp>({
  appearance: 'light',
  theme: light,
  toggleTheme: undefined,
});

const { Provider } = ThemeContext;

const availableThemes = {
  dark: dark,
  light: light,
};

export const useTheme = () => {
  return useContext(ThemeContext).theme as Appearance;
};

export const useAppearance = () => {
  return useContext(ThemeContext).appearance;
};

export const ThemeProvider: React.FC<Partial<ThemeProp>> = ({
  appearance = 'light',
  theme = availableThemes[appearance],
  toggleTheme,
  children,
}) => {
  return (
    <Provider value={{ appearance, theme, toggleTheme }}>{children}</Provider>
  );
};

// ========================================================

export const useColors = () => {
  const { colors } = useTheme();
  return colors;
};

export const useGradients = () => {
  const theme = useTheme();
  return theme.gradients;
};

export const useCardTheme = () => {
  const { card } = useTheme();
  return { cardTheme: card };
}

export const useCircleButtonTheme = () => {
  const { circleButton } = useTheme();
  return { circleButtonTheme: circleButton };
}

export const useLinkTheme = () => {
  const { link } = useTheme();
  return { linkTheme: link };
}

export const useTypographyTheme = () => {
  const { typography } = useTheme();
  return { typographyTheme: typography };
};

export const useButtonTheme = () => {
  const { button } = useTheme();
  return { buttonTheme: button };
};

export const useTooltipTheme = () => {
  const { tooltip } = useTheme();
  return { tooltipTheme: tooltip };
}
